import { PayWithTinabaPayload } from '@/store/modules/linkToPay/types'
import Router from '@/router'

/** Fires Google Analytics event signaling a click on the Tinaba widget */
// function emitWidgetClickedToGoogleAnalytics() {
//   if (window.ga || document.ga) {
//       ga('send', {
//           hitType: 'event',
//           eventCategory: 'Tinaba Widget',
//           eventAction: 'click',
//           eventLabel: 'Pay With Tinaba'
//       });
//   }
// }

interface PayWithTinabaLinks {
  deeplinkUrl: string;
  viaBrowserDeeplinkUrl: string;
}

const deeplinkMerchantUrl = process?.env?.VUE_APP_TINABA_DL_URL || `https://deeplink.tinaba.it/merchant`;

export function getTinabaPayUrl (paymentDetails: PayWithTinabaPayload): PayWithTinabaLinks  {
  let viaBrowserDeeplinkUrl = deeplinkMerchantUrl,
      paymentCode;
  const params = '?',
      scheme = 'it.tinaba.app',
      path = '/dl';

  if ("paymentCode" in paymentDetails) {
    paymentCode = paymentDetails.paymentCode;
  } else {
    throw new Error("Error on retrive paymentCode");
  }

  const deeplinkUrl = `${scheme}:/${path}${params}paymentcode=${encodeURIComponent(paymentCode)}&tinabaPay=true`;
  // QR e link: deeplink.tinaba.it/merchant?paymentCode={code} (paymentCode con la C maiuscola e senza '&',
  // altrimenti lo scanner delle versioni dell'app già installate non lo riconosce)
  viaBrowserDeeplinkUrl += `${params}paymentCode=${encodeURIComponent(paymentCode)}`;

  return {
    deeplinkUrl,
    viaBrowserDeeplinkUrl
  }
}

export function getTinabaPayUniversalLink (paymentDetails: PayWithTinabaPayload): string {
  let params = '?',
      paymentCode;

  if ("paymentCode" in paymentDetails) {
    paymentCode = paymentDetails.paymentCode;
  } else {
    throw new Error("Error on retrive paymentCode");
  }

  params += `paymentCode=${encodeURIComponent(paymentCode)}`;

  const deeplinkUrl = `${deeplinkMerchantUrl}${params}`;

  return deeplinkUrl
}

export function payWithTinaba (paymentDetails: PayWithTinabaPayload) {
  // emitWidgetClickedToGoogleAnalytics();
  // holds the final URL that will be used in the generated QR code and links to redirection page
  const deeplinkUrl = getTinabaPayUniversalLink(paymentDetails)

  if (window.location.href.includes('fromAppTinaba=true')) {
    parent.postMessage(deeplinkUrl, '*');
    return;
  }

  const agent = navigator.userAgent.toLowerCase();
  if (agent.indexOf('iphone') > -1 || agent.toLowerCase().indexOf('ipod') > -1) {
    window.location.replace(deeplinkUrl)
    return null
  } else if (agent.indexOf('android') > -1) {
    window.location.replace(deeplinkUrl)
    return null
  } else {
    return Router.push({ path: `/${paymentDetails.id}/tinaba-pay` })
  }
}
